const SDK_VERSION = '7.31.1';

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
